import { ButtonGroup, Button, ModalBody, ModalFooter } from "@chakra-ui/react";
import { FC } from "react";
import { Field, FieldProps, Form, Formik} from 'formik';
import { object, string } from "yup";
import { ButtonSubmit, FormTextArea, MarkdownCommands, Modal} from "components";
import { usePack, useRunSync } from "lib/hooks";
import { updateAsset } from "../../../api";

const validationSchema = object({
  value: string().required(),
});

export const EditTextModal:FC<any> = ({ asset, onClose, isOpen }) => {
  const { sync } = useRunSync(asset?.pack_id);
  const { data: pack } = usePack(asset?.pack_id);

  if (!asset) {
    return null;
  }

  const onSubmit = async ({ value }): Promise<void> => {
    if (value === asset.data.value) {
      return onClose();
    }

    try {
      await updateAsset({ ...asset, data: { ...asset.data, value }}, pack.key);
      await sync();
      // TODO: Success notification
    } catch (e) {
      // TODO: Error notification
    }

    onClose();
  }

  return (
    <Modal
      title="Edit text"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Formik initialValues={{ value: asset.data.value }} validationSchema={validationSchema} onSubmit={onSubmit}>
        <Form>
          <ModalBody>
            <Field>
              {({ form }: FieldProps) => (
                <MarkdownCommands form={form} forName="value">
                  {(ref: any) => (
                    <FormTextArea name="value" autoFocus={true} ref={ref} inputProps={{minHeight: 150}} />
                  )}
                </MarkdownCommands>
              )}
            </Field>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup width="100%" justifyContent="end">
              <Button variant="cancel" onClick={onClose}>Cancel</Button>
              <ButtonSubmit>Save</ButtonSubmit>
            </ButtonGroup>
          </ModalFooter>
        </Form>
      </Formik>
    </Modal>
  )
};
